/**
 * Mobile vs desktop experience — independent of REACT_APP_APP_VERSION (v1/v2).
 *
 * The editor is desktop-first until a responsive layout ships. Until then,
 * viewports at or below MOBILE_MAX_WIDTH_PX see MobileDesktopOnlyGate instead
 * of landing, sign-in, or the app shell.
 *
 * When mobile UI is ready: set REACT_APP_MOBILE_DESKTOP_GATE=false (or remove it).
 * For local phone testing while the gate is on: same flag in .env.local.
 */
import { MOBILE_MAX_WIDTH_PX } from "../../hooks/app/useIsMobileViewport";

export { MOBILE_MAX_WIDTH_PX };

/** Default true — opt out only when responsive mobile ships. */
export const MOBILE_DESKTOP_GATE_ENABLED =
  (process.env.REACT_APP_MOBILE_DESKTOP_GATE ?? "true").trim().toLowerCase() !==
  "false";
